export const enum EntityType {
  CAMPAIGN = "campaign",
  AD_GROUP = "adGroup",
  AD = "ad",
}
